import OffCanvasSidebar from "../../Components/OffCanvasSidebar/OffCanvasSidebar";
import EmpoweringIndustries from "../../Components/IndustriesSection/EmpoweringIndustries/EmpoweringIndustries";
import MarqueeSlider from "../../Components/LandingSection/MarqueeSlider/MarqueeSlider";
import OurClient from "../../Components/IndustriesSection/OurClient/OurClient";
import OurSolutions from "../../Components/IndustriesSection/OurSolutions/OurSolutions";
import StickyCards from "../../Components/IndustriesSection/StickyCards/StickyCards";
import PerformanceMetrics from "../../Components/IndustriesSection/PerformanceMetrics/PerformanceMetrics";

const IndustriesPage = ({ banner }) => {
  return (
    <>
      {/* <OffCanvasSidebar /> */}
      {/* <div>
        <EmpoweringIndustries />
        <MarqueeSlider banner={banner} />
        <StickyCards />
        <OurClient />
        <OurSolutions />
        <PerformanceMetrics />
      </div> */}

      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#000",
          fontSize: "40px",
          letterSpacing: "0.2px",
        }}
      >
        coming soon...
      </div >
    </>
  );
};

export default IndustriesPage;
